import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { firebaseAuth, firebaseGetAuth } from './firebase/config';
import { FirestoreProvider, useFirebaseApp } from 'reactfire';
import { getFirestore } from 'firebase/firestore';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';

import Main from './components/template/Main';
import Aside from './components/template/Aside';
import Splash from './components/Splash';
import Content from './components/template/Content';
import UsersPage from './pages/UsersPage';
import AlertsPage from './pages/AlertsPage';
import ReportsPage from './pages/ReportsPage';
import UserDetailsPage from './pages/UserDetails';

import AboutUsPage from "./pages/AboutUsPage";
import LegalPage from "./pages/LegalPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import TermsAndConditionsPage from "./pages/TermsAndConditionsPage";
import NotFoundPage from './pages/NotFountPage';

const App: React.FC = () => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
  const [isLoader, setIsLoader] = useState<boolean>(true);
  
  const firestoreInstance = getFirestore(useFirebaseApp());

  useEffect(() => {
    const unsubscribe = firebaseAuth.onAuthStateChanged(firebaseGetAuth, async (user: any) => {
      setIsAuthenticated(!!user);

      await sleep(500);

      setIsLoader(false);
    }, (error: any) => {
      console.log('Error:', error);
      setIsLoader(false);
    });
    
    return () => unsubscribe();
  }, []);

  const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

  if (isLoader) {
    return <Splash />;
  }

  return (
    <FirestoreProvider sdk={firestoreInstance}>
      <Router>
        <Main>
          { isAuthenticated && <Aside />}

          <Content>
            <Routes>
              <Route 
                path="/about-us" 
                element={<AboutUsPage />} 
              />
              <Route 
                path="/legal" 
                element={<LegalPage />} 
              />
              <Route 
                path="/terms-and-conditions" 
                element={<TermsAndConditionsPage />} 
              />
              <Route 
                path="/privacy-policy" 
                element={<PrivacyPolicyPage />} 
              />
              
              <Route 
                path="/login" 
                element={isAuthenticated ? <Navigate to="/" /> : <LoginPage />} 
              />
              <Route 
                path="/" 
                element={isAuthenticated ? <HomePage /> : <Navigate to="/login" />} 
              />
              <Route 
                path="/users" 
                element={isAuthenticated ? <UsersPage /> : <Navigate to="/login" />} 
              />
              <Route 
                path="/users/:id" 
                element={isAuthenticated ? <UserDetailsPage /> : <Navigate to="/login" />} 
              />
              <Route 
                path="/alerts" 
                element={isAuthenticated ? <AlertsPage /> : <Navigate to="/login" />} 
              />
              <Route 
                path="/reports" 
                element={isAuthenticated ? <ReportsPage /> : <Navigate to="/login" />} 
              />

              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </Content>
        </Main>
      </Router>

      <ToastContainer />
    </FirestoreProvider>
  );
};

export default App;